import { toast } from 'react-hot-toast';
export class ToastService {
    static success(message) {
        toast.success(message);
    }
    static error(message) {
        toast.error(message);
    }
}
